











































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { CategoryFacetDto } from '@/api';
import SearchBarStore from '@/stores/search/searchBar.store';
import CompletionProduct from '@/views/product/widgets/CompletionProduct.vue';
import { ProductTuple } from '@/stores/search/util';
import Routes from '@/util/Routes';
import SearchResultStore from '@/stores/search/searchResult.store';
import KeycloakStore from '@/stores/user/keycloak.store';
import BrowseProduct from '@/views/product/widgets/BrowseProduct.vue';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {
    BrowseProduct,
    CompletionProduct,
  },
})
export default class SearchSuggestionDropdown extends Vue {
  private searchBarStore = getModule(SearchBarStore, this.$store);
  private searchResultStore = getModule(SearchResultStore, this.$store);
  private keycloakStore: KeycloakStore = getModule(KeycloakStore, this.$store);

  private suggestionDropDownProductSize = 5;

  public async mounted() {
    // We need this to fix the search suggestion height for mobile views
    window.addEventListener('resize', () => {
      this.setVhVariableToCurrentViewHeight();
    });
    this.setVhVariableToCurrentViewHeight();
  }

  private setVhVariableToCurrentViewHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  get hasProducts(): boolean {
    return this.products && this.products.length > 0;
  }

  get isLoggedIn(): boolean {
    return this.keycloakStore.authenticated;
  }

  get products(): ProductTuple[] {
    return this.searchBarStore.currentProducts.slice(0, this.suggestionDropDownProductSize);
  }

  get childCategories(): CategoryFacetDto[] {
    return ((this.searchBarStore.currentSearchResult.facets || []).childCategoryFacets || [])
        .slice(0, 7);
  }

  get showMoreButton(): boolean {
    return this.totalProducts > this.suggestionDropDownProductSize;
  }

  get totalProducts(): number {
    return this.searchBarStore.currentSearchResult.page?.totalElements ?? 0;
  }

  get moreProducts(): number {
    if (this.totalProducts > 5) {
      return this.totalProducts - this.suggestionDropDownProductSize;
    }
    return 0;
  }

  get moreProductsMessage(): TranslateResult | undefined {
    if (this.moreProducts > 1) {
      return this.$t('message.search.suggestions.moreMulti', {moreProducts: this.moreProducts});
    }

    if (this.moreProducts === 1) {
      return this.$t('message.search.suggestions.moreSingle', {moreProducts: this.moreProducts});
    }
  }

  private getProducts(count: number): ProductTuple[] {
    return this.searchBarStore.currentProducts.slice(0, count);
  }

  private closeSuggestions() {
    this.searchBarStore.setSearchBarActive(false);
  }

  private redirectToCategory(categoryId: string) {
    this.$router.push({
      name: Routes.ProductSearch,
      query: {
        query: this.searchBarStore.currentSearchRequest.queryString,
        currentCategoryId: categoryId,
      },
    });
    const request = this.searchBarStore.currentSearchRequest;
    request.filter = {categoryId};
    this.searchResultStore.updateSearchRequest(request);
    this.closeSuggestions();
  }

  private async redirectToResults() {
    if (this.$router.currentRoute.name !== Routes.ProductSearch ||
        this.$router.currentRoute.query.query !== this.searchBarStore.currentSearchRequest.queryString) {
      await this.$router.push({
        name: Routes.ProductSearch,
        query: {
          query: this.searchBarStore.currentSearchRequest.queryString,
        },
      });
    }

    const request = {
      queryString: this.searchBarStore.currentSearchRequest.queryString,
    };
    await this.searchResultStore.updateSearchRequest(request);
    this.closeSuggestions();
  }
}
